import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import Loading from "../../components/Loading/loading";
import { useDispatch, useSelector } from "react-redux";
import "./StudentDetails.css";
import { clearError, getStudent } from "../../actions/fileAction";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { STUDENT_UPDATE_RESET } from "../../constants/fileConstant";
import MetaData from "../../components/MetaData";
import { darken } from "@mui/material";
import { FaEdit } from "react-icons/fa";

const StudentDetails = () => {
  const dispatch = useDispatch();
  const { error, student, loading } = useSelector((state) => state.oneStudent);

  const { id } = useParams();
  const navigate = useNavigate();

  let date = new Date(student?.createdAt)
  const date_ = date.toString().split('G')[0]
  // console.log(student?.createdAt , date_)
  let update_date = new Date(student?.updatedAt)
  const update_date_ = update_date.toString().split('G')[0]

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch(clearError());
      // setSelectedMultiFile([])
    }

    dispatch(getStudent(id));
  }, [error]);
const  arrays = ["png", "jpg", "jpeg"]
  return (
    <div className="dashboardMain">
        <MetaData title={`Application - ${student?.Name}`}/>

      <div
        className={
          window.innerWidth > 600 ? "menuContainer show" : "menuContainer hide"
        }
      >
        <Sidebar />
      </div>
      {loading ? (
        <Loading />
      ) : (
        <div className="dashboardContainer">
          {/* <DashboardHeader heading={"Students Application"} /> */}

          <div className="StudentDetailsBox">
            <div className="studentUnderBox">
              <div className="su-topHeader">
              <h3>
                Application Detailes ID : {id} <br />
                Last Update :{" "}
                {student?.updatedAt === null ? "No Update" : update_date_}
              </h3>

              <Link to={`/student/details/update/${id}`}>Edit <FaEdit/> </Link>
              </div>

              <div className="st-d-item">
                <div>
                  <p>
                    <b>Name :</b>
                  </p>
                  <p>{student?.Name}</p>
                </div>
                <div>
                  <p>
                    {" "}
                    <b>Course :</b>
                  </p>
                  <p>{student?.Course}</p>
                </div>
              </div>
              <div className="st-d-item">
                <div>
                  <p>
                    <b>Phone :</b>
                  </p>
                  <p>{student?.Phone}</p>
                </div>
                <div>
                  <p>
                    {" "}
                    <b>Email :</b>
                  </p>
                  <p>{student?.Email}</p>
                </div>
              </div>
              <div className="st-d-item">
                <div>
                  <p>
                    <b>Passport:</b>
                  </p>
                  <p>{student?.Passport}</p>
                </div>
                <div>
                  <p>
                    {" "}
                    <b>Serial No:</b>
                  </p>
                  <p>{student?.adhaar}</p>
                </div>
              </div>


              <div className="st-d-item">
                <div>
                  <p>
                    <b>University Name:</b>
                  </p>
                  <p>{student?.University_Name}</p>
                </div>
                <div>
                  <p>
                    {" "}
                    <b>Agent Name:</b>
                  </p>
                  <p>{student?.Agent_Name}</p>
                </div>
              </div>

              <div className="st-d-item">
                <div>
                  <p>
                    <b>Team Name:</b>
                  </p>
                  <p>{student?.Team_Name}</p>
                </div>
                <div>
                  <p>
                    {" "}
                    <b>Intake:</b>
                  </p>
                  <p>{student?.Intake}</p>
                </div>
              </div>

              
              <div className="st-d-item">
                <div>
                  <p>
                    <b>Date Of Birth:</b>
                  </p>
                  <p>{student?.Date_Of_Birth}</p>
                </div>
                <div>
                  <p>
                    {" "}
                    <b>Region:</b>
                  </p>
                  <p>{student?.Region}</p>
                </div>
              </div>
              
              <div className="st-d-item">
                <div>
                  <p>
                    <b>Appliction Id:</b>
                  </p>
                  <p>{student?.Application_Id}</p>
                </div>
                <div>
                  <p>
                    {" "}
                    <b>Student_Id:</b>
                  </p>
                  <p>{student?.Student_Id}</p>
                </div>
              </div>


              <div className="st-d-item">
                <div>
                  <p>
                    <b>Payment :</b>
                  </p>
                  <p>{student?.Payment }</p>
                </div>
                <div>
                  <p>
                    {" "}
                    <b>Mode of Payment:</b>
                  </p>
                  <p>{student?.Mode_of_Payment}</p>
                </div>
              </div>

              <div className="st-d-item">
                <div>
                  <p>
                    <b>Suitability Interview :</b>
                  </p>
                  <p>{student?.Suitability_Interview }</p>
                </div>
                <div>
                  <p>
                    {" "}
                    <b>Credibility Interview:</b>
                  </p>
                  <p>{student?.Credibility_Interview}</p>
                </div>
              </div>

              <div className="st-d-item">
                <div>
                  <p>
                    <b>CAS Request Date :</b>
                  </p>
                  <p>{ student?.CAS_Request_Date }</p>
                </div>
                <div>
                  <p>
                    {" "}
                    <b>Education Verification:</b>
                  </p>
                  <p>{student?.Education_Verification}</p>
                </div>
              </div>

              <div className="st-d-item">
                <div>
                  <p>
                    <b>Financial Verification :</b>
                  </p>
                  <p>{student?.Financial_Verification }</p>
                </div>
                <div>
                  <p>
                    {" "}
                    <b>Affidavit:</b>
                  </p>
                  <p>{student?.Affidavit}</p>
                </div>
              </div>
              {/* last  */}
              
              <div className="st-d-item">
                <div>
                  <p>
                    <b>Country :</b>
                  </p>
                  <p>{student?.Country}</p>
                </div>
                <div>
                  <p>
                    {" "}
                    <b>Create At:</b>
                  </p>
                  <p>{date_}</p>

                </div>
              </div>
             

              <div className="st-d-item">
              <div>
                  <p>
                    {" "}
                    <b>Status</b>
                  </p>
                  <p>{student?.status}</p>
                </div>
                <div>
                  <p>
                    {" "}
                    <b>CO Recived Date:</b>
                  </p>
                  <p>{student?.CO_Received_Date}</p>
                </div>
              </div>

              {/* images  */}

              <div className="st-document-item">
                {student.documentsFiles &&
                  student.documentsFiles.map((item) => (
                    <div className="doc-item">
                      <div>
                        <p>
                          <b>Document :</b> {item.doc_name}
                        </p>
                        <a href={item.url} target="_blank" download>
                          Download
                        </a>
                      </div>
                      <div>
                        {/* <img src={require("../../images/doc.jpg")} alt="k" /> */
                        arrays.includes(item.url.split(".")[3])
                        }
                        {  

                        arrays.includes(item.url.split(".")[3] ) ? (<img src={item.url} alt="file" />) : ( <img src={'https://cdn-icons-png.flaticon.com/512/2246/2246713.png'} alt="file" />)
                       }

                        
                       
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentDetails;
